import { Checkbox } from "@/components/ui/checkbox";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { UseFormReturn, FieldValues, Path } from "react-hook-form";
import { cn } from "@/lib/utils";

interface FormCheckboxProps<T extends FieldValues> {
  label: string;
  form: UseFormReturn<T>;
  id: Path<T>;
  className?: string;
  formClasses?: string;
  disabled?: boolean;
  checkboxClasses?: string;
  onChange?: (value: string | boolean) => void;
  checked?: boolean;
}
export default function FormCheckbox<T extends FieldValues>({
  label,
  form,
  id,
  className,
  formClasses,
  disabled,
  checkboxClasses,
  onChange,
  checked,
}: FormCheckboxProps<T>) {
  return (
    <FormField
      control={form.control}
      name={id}
      render={({ field }) => (
        <FormItem
          className={cn(
            "flex items-center justify-start space-x-2",
            formClasses,
          )}
        >
          <FormControl className="flex items-center justify-center">
            <Checkbox
              className={cn("rounded-sm border-bg-border", checkboxClasses)}
              checked={checked ? checked : field.value}
              // onCheckedChange={field.onChange}
              onCheckedChange={(e) => {
                if (onChange) {
                  onChange(e);
                }
                return field.onChange(e);
              }}
              disabled={disabled}
            />
          </FormControl>
          <FormLabel className={cn("mb-1.5", className)}>{label}</FormLabel>
          {/* </div> */}
        </FormItem>
      )}
    />
  );
}
